<template>
  <nav class="navbar navbar-expand-lg navbar-light bg-light fixed-top" style="direction: initial;">
    <a class="navbar-brand    myBasket " href="#">
      <button class="btn ms-4" v-if="cards.length === 0">
        <i class="fa fa-shopping-cart " style="font-size: 21px" @click="emptyBasket()"></i>
        <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">{{
            cards?.length
          }}  </span>
      </button>
      <Popper v-else c>
        <button class="btn text-primary">
          <i class="fa fa-shopping-cart " style="font-size: 21px" @click="emptyBasket()"></i>
          <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">{{
              cards?.length
            }}  </span>
        </button>
        <template #content>
          <div
              class="w-full max-w-md p-4 bg-white border border-gray-200 rounded-lg shadow sm:p-8 dark:bg-gray-800 dark:border-gray-700" >
            <div class="flex items-center justify-center mb-4">
              <h5 class="text-xl text-center font-bold leading-none text-gray-900 dark:text-black">سبد خرید</h5>
            </div>
            <hr>
            <div class="flow-root" >
              <ul role="list" class="divide-y divide-gray-200 dark:divide-gray-700" style="overflow: auto; height: 400px;">
                <li class="p-2" v-for="(card , index) in  cards" style="border-bottom: 1px solid #00000026">
                  <div class="flex items-center ">
                    <div class="flex-1 min-w-0 ms-4">
                      <p class="text-sm p-2 font-medium text-gray-900 truncate dark:text-black">
                        <a href="#" class="font-medium text-red-600 dark:text-red-500 hover:underline"  @click="removeItme(card?.id , card?.price)"> <i class="fa fa-trash  " ></i></a>
                        {{ card?.title }}
                      </p>
                       <p class="text-right text-sm">
                       <pre class="font-bold text-body-secondary text-sm"> قیمت:{{ num.numberFormats(card?.price) }} تومان </pre>
                       </p>
                    </div>
                    <div class="flex-shrink-0">
                      <img class="w-5 h-5 rounded-full" src="../../../assets/images/logo.png" alt="Neil image">
                    </div>
                  </div>
                </li>
              </ul>
              <div class="flex items-center justify-between">
                <router-link to="/agents/panel/checkout" class="text-white bg-gradient-to-r from-red-400 via-red-500 to-red-600 hover:bg-gradient-to- focus:ring-4 focus:outline-none focus:ring-red-300 dark:focus:text-gray-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2 btn p-2" title="برای مشاهد سبد خرید کلیک کنید"
                             style="font-size: 10px">
                  تسویه حساب
                </router-link>
                   <span class="text-3xl font-bold text-gray-900 dark:text-black">
                   <span class="ms-2 text-sm ">  مبلغ قابل پرداخت</span><br>
                  <span class="myRoman text-sm text-bold text-sky-600  font-bold ms-2 ">{{ num.numberFormats(total) }} تومان  </span>
                </span>

              </div>
            </div>
          </div>

        </template>
      </Popper>

      <button class="navbar-toggler ms-4" type="button" data-bs-toggle="mcollapse"
              data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
              aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
    </a>
    <div>
      <ul class="navbar myNavbar">
        <!--        <li class="nav-item nav">-->
        <!--   -->
        <!--        </li>-->

      </ul>
    </div>

  </nav>
</template>
<script setup>
import Popper from "vue3-popper";
import {useStore} from 'vuex'
import {computed} from "vue";
import {useToast} from "vue-toastification";
import * as num from "@/common/helpers/Number";

const toast = useToast();
const store = useStore()

const cards = computed(() => {
  store.dispatch('statusType', {'status': ""});
  return (store?.state?.listCard) ? store.state.listCard : 0;
});

const total = computed(() => {
  return (store.state.listCard) ? store.state.total : 0;
});

function getCart() {
  store.commit('getCart');
  store.commit('getTotalCar');
}

function emptyBasket() {
  store.dispatch('statusStep', {'status': false});
}

function navRight() {
  store.dispatch('navRight', {'status': false});
}

function removeItme(id, price) {
  store.dispatch('removeCart', {id: id, 'price': price});
}

getCart();

</script>
<style scoped>

</style>

